<div class="alerts">
  <page-alert [message]="messageSuccess" *ngIf="showSuccessMessage" alertClass="alert-success"></page-alert>
  <page-alert [message]="messageError" *ngIf="showErrorMessage" alertClass="alert-danger"></page-alert>
</div>

<form [formGroup]="form">
  <div class="row align-items-start">
    <div class="col-xs-12 col-md-3">
      <div class="photo-upload text-center">
        <div *ngIf="profilePictureUrl" class="preview">
          <img [src]="profilePictureUrl" alt="Foto de perfil" class="profile-picture-preview" />
        </div>
        <button mat-raised-button color="primary" (click)="fileInput.click()">Alterar Foto</button>
        <input type="file" #fileInput (change)="onFileSelected($event)" accept="image/*" style="display: none" />

        <mat-error *ngIf="form.get('photo')?.hasError('maxFileSize') ">
          O arquivo deve ter um tamanho menor que 4mb
        </mat-error>

        <mat-error *ngIf="form.get('photo')?.hasError('invalidFileType') ">
          Permitido apenas imagems em png e jpeg
        </mat-error>

      </div>
    </div>
    <div class="col-xs-12 col-md-9 form-fields">
      <div class="row">
        <div class="col-xs-12 col-md-4">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Nome</mat-label>
            <input type="text" matInput formControlName="name" placeholder="Nome" required
              (keypress)="allowOnlyLetters($event)" (paste)="onPasteName($event)" />
            <mat-error *ngIf="form.get('name')?.hasError('required')"> Campo obrigatório </mat-error>
            <mat-error *ngIf="form.get('name')?.hasError('pattern')"> O nome deve conter apenas letras </mat-error>
          </mat-form-field>
        </div>
    
      
     
        <div class="col-xs-12 col-md-4">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>CPF</mat-label>
            <input type="text" matInput formControlName="cpf" placeholder="000.000.000-00" mask="000.000.000-00"
              required />
            <mat-error *ngIf="form.get('cpf')?.hasError('required')"> É obrigatório informar um CPF válido </mat-error>
            <mat-error *ngIf="form.get('cpf')?.hasError('pattern')"> CPF inválido </mat-error>
          </mat-form-field>
        </div>
        <div class="col-xs-12 col-md-4">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Telefone</mat-label>
            <input matInput type="text" formControlName="mobile" mask="(00) 00000-0000" prefix="+55 "
              [dropSpecialCharacters]="true" placeholder="(11) 91234-5678" required (paste)="onPasteName($event)" />
            <mat-error *ngIf="form.get('mobile')?.hasError('required')"> Campo obrigatório </mat-error>
          </mat-form-field>
        </div>
    </div>
    </div>
  </div>
</form>

<div class="col-xs-12 btCriar">
  <button mat-flat-button color="primary" *ngIf="mode === 'UPDATE'" (click)="save()" [disabled]="form.invalid || isSaving">
    <ng-container *ngIf="!isSaving">Salvar</ng-container>
    <ng-container *ngIf="isSaving">
      <mat-progress-spinner mode="indeterminate" diameter="20" strokeWidth="3"></mat-progress-spinner>
    </ng-container>
  </button>

  

  <button mat-flat-button color="primary" *ngIf="mode === 'CREATE'" (click)="create()" [disabled]="form.invalid || isSaving">
    <ng-container *ngIf="!isSaving">Criar Especialista</ng-container>
    <ng-container *ngIf="isSaving">
      <mat-progress-spinner mode="indeterminate" diameter="20" strokeWidth="3"></mat-progress-spinner>
    </ng-container>
  </button>
</div>